"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const uuid_1 = require("uuid");
const memoize_one_1 = __importDefault(require("memoize-one"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const react_router_dom_1 = require("react-router-dom");
const Card_1 = __importDefault(require("@mui/material/Card"));
const actions_1 = require("companion-app-components/flux/preferences/actions");
const selectors_1 = require("companion-app-components/flux/preferences/selectors");
const ErrorBoundary_1 = __importDefault(require("components/ErrorBoundary"));
const TransactionRegister_1 = __importDefault(require("components/TransactionRegister"));
const utils_1 = require("./utils");
const uniqueName = (0, uuid_1.v4)();
const EmbeddedRegister = ({ name, accountIds, overrideTxns, regFieldsOrder, fitToWindow, hideFooter = true, sizeToContent, zeroStateMessage, zeroStateStyle = {}, calendar, scrollToId, onTxnUpdate, elevation, style, className, getInsideRef, onSortChange, hideDividers = true, hideSearch = true, hideColumnsHeader, bottomMargin, doubleAmounts, editDownloaded, deleteDownloaded, splitsInDialog, autoSave, wrapText, longCats, showCurrencySymbol, showAccountColors, addNewTransactionRef, webFirstCatUncategorize, currency = 'USD', reminderSetting = '999', registerComfort = 'normal', sortBy: initialSortBy = 'date', sortOrder: initialSortOrder = 'descending', }) => {
    const [regWinHeight, setRegWinHeight] = (0, react_1.useState)(0);
    const [sortBy, setSortBy] = (0, react_1.useState)(initialSortBy);
    const [sortOrder, setSortOrder] = (0, react_1.useState)(initialSortOrder);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const datasetPreferences = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getSharedPreferencesByPath)(state, { group: 'dataset', path: ['webApp'] }));
    (0, react_1.useEffect)(() => {
        if (!datasetPreferences) {
            dispatch((0, actions_1.getPreferences)({ section: 'shared', group: 'dataset' }));
        }
    }, [datasetPreferences, dispatch]);
    const calcRegisterHeight = (0, react_1.useCallback)(() => {
        const node = document.getElementById(name);
        if (node) {
            const { top } = (0, utils_1.getCoords)(node);
            return window.innerHeight - top - bottomMargin;
        }
        return window.innerHeight;
    }, [name, bottomMargin]);
    const updateDimensions = (0, react_1.useCallback)((force = false) => {
        if (force || fitToWindow) {
            setRegWinHeight(calcRegisterHeight());
        }
    }, [fitToWindow, calcRegisterHeight]);
    (0, react_1.useEffect)(() => {
        const handleResize = () => updateDimensions();
        window.addEventListener('resize', handleResize);
        setTimeout(updateDimensions, 100);
        return () => window.removeEventListener('resize', handleResize);
    }, [updateDimensions]);
    (0, react_1.useEffect)(() => {
        if (getInsideRef) {
            getInsideRef();
        }
    }, [getInsideRef]);
    const cardStyleCached = (0, react_1.useMemo)(() => (0, memoize_one_1.default)((obj) => obj, isEqual_1.default), []);
    const regRef = () => {
        if (fitToWindow) {
            setTimeout(() => {
                updateDimensions();
            }, 100);
        }
    };
    const navigateTo = (0, react_1.useCallback)((accountId, txnId) => {
        navigate(`/transactions?displayNode=${accountId}&txnId=${txnId}`, { replace: true });
    }, [navigate]);
    // eslint-disable-next-line consistent-return
    const handleSortChange = (0, react_1.useCallback)((newSortBy, newSortOrder) => {
        if (onSortChange) {
            return onSortChange(newSortBy, newSortOrder);
        }
        setSortBy(newSortBy);
        setSortOrder(newSortOrder);
    }, [onSortChange]);
    const { transactionRegister: regPrefs } = datasetPreferences;
    return (<ErrorBoundary_1.default>
      <Card_1.default id={name || uniqueName} elevation={elevation} style={cardStyleCached(Object.assign({ height: fitToWindow ? `${regWinHeight || calcRegisterHeight()}px` : 'inherit' }, style))} className={className}>
        <TransactionRegister_1.default wrapperId={name || uniqueName} accountIds={accountIds} overrideTxns={overrideTxns} doubleAmounts={doubleAmounts === undefined ? regPrefs.doubleAmounts : doubleAmounts} editDownloaded={editDownloaded === undefined ? regPrefs.editDownloaded : editDownloaded} deleteDownloaded={deleteDownloaded === undefined ? regPrefs.deleteDownloaded : deleteDownloaded} splitsInDialog={splitsInDialog === undefined ? regPrefs.splitsInDialog : splitsInDialog} autoSave={autoSave === undefined ? regPrefs.autoSave : autoSave} registerComfort={registerComfort === undefined ? regPrefs.registerComfort : registerComfort} wrapText={wrapText === undefined ? regPrefs.wrapText : wrapText} autoSearch={false} longCats={longCats === undefined ? regPrefs.longCats : longCats} continuousCreate={false} showCurrencySymbol={showCurrencySymbol === undefined ? regPrefs.showCurrencySymbol : showCurrencySymbol} showAccountColors={showAccountColors === undefined ? regPrefs.showAccountColors : showAccountColors} currency={currency || 'USD'} getRef={regRef} navFn={navigateTo} showControls hideDividers={hideDividers} hideSearch={hideSearch} hideColumnsHeader={hideColumnsHeader} noNew regFieldsOrder={regFieldsOrder || utils_1.regFieldsOrderDefault} hideFooter={hideFooter} sizeToContent={sizeToContent} zeroStateMessage={zeroStateMessage} zeroStateStyle={zeroStateStyle} reminderSetting={reminderSetting} calendar={calendar} sortOrder={sortOrder} sortBy={sortBy} onSortChange={handleSortChange} addNewTransactionRef={addNewTransactionRef} webFirstCatUncategorize={webFirstCatUncategorize} scrollToId={scrollToId} onTxnUpdate={onTxnUpdate}/>
      </Card_1.default>
    </ErrorBoundary_1.default>);
};
exports.default = EmbeddedRegister;
